<template>
    <div>
        <div v-if="styleMode===0" class="agx-list-oneInRow" v-bind:style="{'height':'1124px','background-size': '100% auto','margin-top':0,'margin-bottom':0,'border':0}">
            <div style="text-align:center;vertical-align:central;">
                <div v-if="item.title!=='' || item.textMsg!==''" style="position: absolute;
                            z-index: 99;
                            display:inline-block;
                            top:10px;
                            background: rgba(251, 249, 249, 0.6);
                            padding-right: 4px;
                            padding-left: 4px;
                            right:0;
                            border-radius:10px;
                            min-width:30%;
                            ">
                    <div style="display: inline-block;">
                        <div style="font-size: 2em; font-weight: bold; padding: 2px;">
                            <router-link :to="{name:detailPage,query:{postId:item.postId}}" v-if="item.title!==''">
                                {{item.title}}
                            </router-link>
                        </div>
                        <div style="text-align:center;float:right;max-width:50%;">
                            <template v-if="item.images.length>1">
                                <img class="img-responsive" v-for="(img,index) in item.images" v-if="index!==0" :src="img.thumbPath" style="display:inline-block;width:200px;border-radius:12px;margin:4px;" />
                            </template>
                        </div>
                        <div style="padding: 2px; white-space: pre-line; font-size: 1.5em; font-weight: bolder;" v-if="item.textMsg!==''">
                            <div>{{item.textMsg}}</div>
                        </div>
                    </div>

                </div>
                
                <div class="col-xs-4 col-md-4" style="padding-left:0px;">
                    <router-link :to="{name:detailPage,query:{postId:item.postId}}">
                        <img style="display:inline-block;height:800px;"
                             class="agx-post-thumb" :src="item.images[0].path" :title="item.title">
                    </router-link>
                </div>
            </div>

        </div>

        <div v-if="styleMode===1" class="agx-list-oneInRow" v-bind:style="{'height':'1124px','background-size': '100% auto','margin-top':0,'margin-bottom':0,'border':0}">
            <div>
                <div style="position: absolute;
                            z-index: 99;
                            right: 0;
                            background: rgba(251, 249, 249, 0.6);">

                    <router-link :to="{name:detailPage,query:{postId:item.postId}}">
                        <img style="display:inline-block;height:800px;"
                             class="agx-post-thumb" :src="item.images[0].path" :title="item.title">
                    </router-link>
                </div>
                <div style="position: absolute; left: 0px; right: 0px; height: 100%; background: rgba(250, 250, 250, 0.8);"></div>
                <div>
                    <div v-if="item.title!=='' || item.textMsg!==''" style="position: absolute;left:0;text-align:center;z-index: 99; display: inline-block;top:10px;background: rgba(251, 249, 249, 0.7); padding-right: 4px; padding-left: 4px;border-radius:10px;min-width:30%;">
                        <div style="font-size:1.6em;font-weight:bold;padding:2px;">
                            <router-link :to="{name:detailPage,query:{postId:item.postId}}" v-if="item.title!==''">
                                {{item.title}}
                            </router-link>
                        </div>
                        <div style="padding: 2px; white-space: pre-line; font-size: 1.5em;font-weight:bolder;" v-if="item.textMsg!==''">
                            <div>{{item.textMsg}}</div>
                        </div>
                        <div style="text-align:center;float:left;max-width:50%;">
                            <template v-if="item.images.length>1">
                                <img class="img-responsive" v-for="(img,index) in item.images" v-if="index!==0" :src="img.thumbPath" style="display:inline-block;width:200px;border-radius:12px;margin:4px;" />
                            </template>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>
<script>

    export default {
        components: {

        },
        filters: {
            cutContent: function (txtMsg) {
                if (txtMsg === null) return;
                var length = 50;
                return txtMsg.length > length ? txtMsg.slice(0, length) + "......" : txtMsg;
            }
        },
        props: {
            "item": Object,
            "styleMode": Number,
            "detailPage": { type: String, default: "articleDetail" }
        },
        data: function () {
            return {

            }
        },
        mounted: function () {

        }
    }
</script>